import { ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import { grey } from '@mui/material/colors';
import makeStyles from '@mui/styles/makeStyles';
import Bowser from 'bowser';
import { orderBy } from 'lodash';
import { useContext } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { AdContext } from '../../contexts/ads-context';
import { FooterAdItem } from './footer-ad-item';

const detectMobile = (): boolean => {
  const parser = Bowser.getParser(window.navigator.userAgent);
  return parser.getPlatform().type === 'mobile';
};

const useStyles = makeStyles({
  carouselContainer: {
    paddingRight: 25,
    paddingLeft: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  carouselItem: {
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'center',
  },
  carouselButtons: {
    borderRadius: 50,
    display: 'flex',
    justifyContent: 'center',
    opacity: 0.7,
    '&:hover': {
      backgroundColor: grey[900],
      opacity: 1,
    },
  },
});

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
    partialVisibilityGutter: 40,
  },
  largeDesktop: {
    breakpoint: { max: 3000, min: 1600 },
    items: 4,
    partialVisibilityGutter: 40,
  },
  desktop: {
    breakpoint: { max: 1600, min: 900 },
    items: 3,
    partialVisibilityGutter: 40,
  },
  tablet: {
    breakpoint: { max: 900, min: 600 },
    items: 2,
    partialVisibilityGutter: 30,
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 1,
    partialVisibilityGutter: 90,
  },
};

export function FooterAdCarousel() {
  // Context
  const { state } = useContext(AdContext);
  // Hooks
  const classes = useStyles();
  const isMobile = detectMobile();

  // @ts-ignore
  const ButtonGroup = ({ next, previous }) => {
    return (
      <Box
        className="custom-button-group"
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'absolute',
          top: '50%',
          bottom: '50%',
          px: 2,
        }}
      >
        <IconButton
          color="primary"
          className={classes.carouselButtons}
          onClick={() => previous()}
        >
          <ArrowBackIosNew />
        </IconButton>
        <IconButton
          color="primary"
          className={classes.carouselButtons}
          onClick={() => next()}
        >
          <ArrowForwardIos />
        </IconButton>
      </Box>
    );
  };

  if (state.footerTiles.length > 0) {
    return (
      <Box
        className="carousel-wrapper"
        maxWidth="lg"
        width="100%"
        sx={{
          position: 'relative',
          ml: 'auto',
          mr: 'auto',
          mt: 4,
          borderRadius: 3,
        }}
      >
        <Carousel
          className={classes.carouselContainer}
          responsive={responsive}
          removeArrowOnDeviceType={['tablet', 'mobile']}
          infinite
          autoPlay
          partialVisible
          renderButtonGroupOutside={true}
          // @ts-ignore
          customButtonGroup={!isMobile ? <ButtonGroup /> : null}
          arrows={false}
          itemClass={classes.carouselItem}
        >
          {orderBy(state.footerTiles, 'OrderIndex', 'asc').map((item) => {
            return <FooterAdItem key={item.AdId} data={item} />;
          })}
        </Carousel>
      </Box>
    );
  } else {
    return null;
  }
}
